import React from 'react';
import { NavLink } from 'react-router-dom';
import ReactPlayer from 'react-player';


var img1 = require('./../../images/main1.jpg');

class OurValue2 extends React.Component {
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-white mobile-page-padding">
                    <div className="container">
                        <div className="section-content">
                            <div className="row">
                                <div className="col-md-7 col-sm-6">
                                    <div className="video-section-full-v2">
                                        <div className="video-section-full bg-no-repeat bg-cover overlay-wraper m-b30" style={{ backgroundImage: 'url(' + img1 + ')' }}>
                                            <div className="overlay-main bg-black opacity-01" />
                                                <div className="video-section-inner">
                                                    <div className="video-section-content">
                                                        <div className="video-section-left">
      
                                                        </div>
                                                    </div>
                                                </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-5 col-sm-6">
                                    {/* TITLE START */}
                                    <div className="video-part-2">
                                        <h3><span className="font-weight-100">Driven by Safety.</span>Built on Teamwork. Delivered with Excellence</h3>
                                        <p>Our greatest strength lies in our people. Behind every successful project is a dedicated team of trained professionals — planners, engineers, and technicians — working together to ensure safety, precision, and timely delivery.</p>
                                        <ul className="list-angle-right anchor-line">
                                        <li><NavLink>Fire Safety Planning & Installation</NavLink></li>
                                            <li><NavLink>Pre-Construction Safety Audits</NavLink></li>
                                            <li><NavLink>Site Management & Compliance</NavLink></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="myModal" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <ReactPlayer url='https://vimeo.com/34741214' />
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default OurValue2;